import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import { useTranslation } from 'react-i18next';

import { TicketTabResolved } from './ticket-tab-resolved.component';
import { TicketTabTodo } from './ticket-tab-todo.component';

export enum TicketTabKey {
  Todo = 'todo',
  Resolved = 'resolved',
}

interface TicketListViewProps {
  activeTab: TicketTabKey;
  onTabChange: (tab: TicketTabKey) => void;
  onActionRead: (id: string) => void;
}

export const TicketListView = ({
  activeTab,
  onTabChange,
  onActionRead,
}: TicketListViewProps): React.JSX.Element => {
  const { t } = useTranslation();

  const tabElements = [
    {
      key: TicketTabKey.Todo,
      title: t('$.ticket-list.tab-todo'),
      icon: 'file-02' as const,
    },
    {
      key: TicketTabKey.Resolved,
      title: t('$.ticket-list.tab-resolved'),
      icon: 'file-check-02' as const,
    },
  ];

  return (
    <Stack direction="column" gap={GapEnum.L}>
      <Tabs
        currentTab={activeTab}
        onTabClick={onTabChange}
        elements={tabElements}
      />
      {activeTab === TicketTabKey.Todo && (
        <TicketTabTodo onActionRead={onActionRead} />
      )}
      {activeTab === TicketTabKey.Resolved && (
        <TicketTabResolved onActionRead={onActionRead} />
      )}
    </Stack>
  );
};
